function cleanObject(value) {
  if (Array.isArray(value)) {
    return value
      .map(cleanObject)
      .filter((item) => item !== undefined && item !== null && item !== "");
  }

  if (value && typeof value === "object") {
    const next = Object.entries(value).reduce((acc, [key, innerValue]) => {
      const cleaned = cleanObject(innerValue);

      if (
        cleaned !== undefined &&
        cleaned !== null &&
        cleaned !== "" &&
        !(typeof cleaned === "object" && !Array.isArray(cleaned) && !Object.keys(cleaned).length) &&
        !(Array.isArray(cleaned) && !cleaned.length)
      ) {
        acc[key] = cleaned;
      }

      return acc;
    }, {});

    return Object.keys(next).length ? next : undefined;
  }

  return value;
}

export function isAssistantRoute(pathname = "") {
  return (
    pathname.startsWith("/Nanoox") ||
    pathname.startsWith("/Flux") ||
    pathname.startsWith("/Scapp")
  );
}

export function resolveRouteContext({ pathname = "", registeredContext }) {
  if (!isAssistantRoute(pathname) || !registeredContext) {
    return null;
  }

  return cleanObject(registeredContext);
}
